import template from './basic.html';
import BasicController from './basic.controller';

class BasicComponent {
	/*@ngInject*/
	constructor() {
		this.scope = {};
		this.restrict = 'E';
		this.template = template;
		this.controller = BasicController;
		this.controllerAs = 'basic';
		this.bindToController = BasicController.bindings;
	}
}

export default BasicComponent;



// WEBPACK FOOTER //
// ./client/app/components/basic/basic.component.js